<template>
  <div class="manager">
     <Loading v-show="loading"></Loading>
     <div class="" v-if="isConfirm==0">
      <div id="tab">
        <ul class="tabMenu">
          <li class="tabItem" v-for="(tab,index) in tabs" v-on:click="activetab=(index+1)" v-bind:class="[ activetab === (index+1) ? 'active' : '' ]">{{tab.tabitem}}</li>
        </ul>
        <div v-if="activetab === 1">
          <table v-for="(purchase, index) of purchases" :key="purchase" class="contact-inner">
          　<tr v-if="purchase.plan === 0">
          　　 <td class="date">日付</td>
          　　 <td class="plan">プラン名</td>
              <td class="name">名前</td>
              <td class="place">場所</td>
              <td class="price">料金</td>
              <td class="presence">症状の有無</td>
              <td></td>
          　</tr>
            <tr v-if="purchase.plan === 0">
          　　<td >{{ purchase.buyDateString }}</td>
          　　<td>{{ purchase.planString }}</td>
              <td>{{ purchase.name }}</td>
              <td>{{ purchase.place }}</td>
              <td>{{ purchase.amount }}</td>
              <td>{{ purchase.isSymptom }}</td>
              <td><button id="delete" @click="deleteData(purchase.id)">削除</button></td>
          　</tr>
            <tr v-if="purchase.plan === 2">
            　　 <td class="date">日付</td>
          　　 <td class="plan">プラン名</td>
              <td class="name">名前</td>
              <td class="place">場所</td>
              <td class="price">料金</td>
              <td class="passport">パスポート画像</td>
              <td class="ticket">チケット画像</td>
              <td></td>
            　</tr>
              <tr v-if="purchase.plan === 2">
            　　<td>{{ purchase.buyDateString }}</td>
          　　<td>{{ purchase.planString }}</td>
              <td>{{ purchase.name }}</td>
              <td>{{ purchase.place }}</td>
              <td>{{ purchase.amount }}</td>
              <td>
                <a v-if="purchase.passport === 'null'" >添付なし</a>
                <a v-else :href="purchase.passport">表示</a>
              </td>
              <td>
                <a v-if="purchase.ticket === 'null'" >添付なし</a>
                <a v-else :href="purchase.ticket">表示</a>
              </td>
              <td><button id="delete" @click="deleteData(purchase.id)">削除</button></td>
            　</tr>
            <tr v-if="purchase.plan === 3">
            　　<td class="date">日付</td>
          　　 <td class="plan">プラン名</td>
              <td class="name">名前</td>
              <td class="place">場所</td>
              <td class="price">料金</td>
              <td class="presence">症状の有無</td>
              <td></td>
            　</tr>
              <tr v-if="purchase.plan === 3">
            　　<td>{{ purchase.buyDateString }}</td>
          　　<td>{{ purchase.planString }}</td>
              <td>{{ purchase.name }}</td>
              <td>{{ purchase.place }}</td>
              <td>{{ purchase.amount }}</td>
              <td>{{ purchase.isSymptom }}</td>
              <td><button id="delete" @click="deleteData(purchase.id)">削除</button></td>
            　</tr>
            </table>
        </div>
        <div class="form" v-else>
          <table v-for="(contact, index) of contacts" :key="contact" class="contact-inner">
          　<tr v-if="contact.type === 0">
          　　 <td class="date">日付</td>
          　　 <td class="name">名前</td>
              <td class="mail">メール</td>
              <td class="tel">電話番号</td>
              <td class="content">内容</td>
              <td></td>
          　</tr>
            <tr v-if="contact.type === 0">
          　　<td>{{ contact.dateString }}</td>
          　　<td>{{ contact.name }}</td>
              <td>{{ contact.mail }}</td>
              <td>{{ contact.tel }}</td>
              <td>{{ contact.content }}</td>
              <td><button id="delete" @click="deleteContactData(contact.id)">削除</button></td>
          　</tr>
            <tr v-if="contact.type === 1">
            　　 <td>日付</td>
              <td>会社名</td>
              <td>団体名</td>
            　　 <td>名前</td>
                <td>メール</td>
                <td>電話番号</td>
                <td></td>
            　</tr>
              <tr v-if="contact.type === 1">
            　　<td>{{ contact.dateString }}</td>
            　　<td>{{ contact.name }}</td>
            <td>{{ contact.company }}</td>
            <td>{{ contact.institution }}</td>
                <td>{{ contact.mail }}</td>
                <td>{{ contact.tel }}</td>
                <td><button id="delete" @click="deleteContactData(contact.id)">削除</button></td>
            　</tr>
            </table>
        </div>
      </div>
    </div>
    <div class="" v-else>
      <div class="card-content">
        <Loading v-show="loading"></Loading>
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
        <input type="text" placeholder="パスワード" v-model="password">
        <button id="login" @click="login">管理者認証</button>
      </div>

    </div>
  </div>
</template>
<style scoped>
*{
  box-sizing: border-box;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
#tab{
  max-width: 80%;
  margin: 16px auto;
}

.tabMenu{
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  list-style: none;
  border-bottom: 1px solid #5D99FF;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid #5D99FF;
  border-right: 1px solid #5D99FF;
  border-top: 1px solid #5D99FF;
  color: black;
  font-weight: bold;
  text-align: center;
}
.tabItem.active{
  background-color: #5D99FF;
  color: #fff;
}

@media ( max-width : 600px ){
  #tab{
  max-width: 90%;
  margin: 16px auto;
}
}
#top #login:hover{
  opacity: 0.7;
}
.card-content{
  padding:8px;
  width: 100%;
  height: auto;
  background-color: white;
  margin: 0 auto;
}
.contact-inner {
  background-color: white;
  border-radius: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 8px;
  box-shadow: 10px 10px 10px 5px rgba(0,0,0,0.4);
  margin-left: 5%;
  width: 100%;
  margin: 24px auto;
  border: 2px solid #5D99FF;
  position: relative;
  font-size: 12px;
  text-align: left;
}
.contact-inner .date{  }

</style>
<script>
import $ from 'jquery'
import Loading from './common/Loading'
import firebase from 'firebase'
import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: 'Search',
  components: {
    Loading, VueTimepicker, Datepicker
  },
  data () {
    return {
      userId: null,
      db: null,
      loading: false,
      storage: null,
      activetab: 1,
      contacts: [],
      purchases: [],
      users: [],
      places: [],
      ja: ja,
      DatePickerFormat: 'yyyy-MM-dd',
      format: 'HH:mm',
      isConfirm: 1,
      password: null,
      tabs: [
      { tabitem: "購入" },
      { tabitem: "お問い合わせ" }
    ],
    contents: [
      {
        position: 0
      },
      {
        position: 1
      }
    ]
    }
  },
  methods: {
    search: function () {
      let self = this
    },
    deleteData: function (id) {
      console.log(id)
      let self = this
      self.loading = true
      this.db.collection('payments').doc(id).delete().then(function() {
          alert('支払いの対応を完了しました。')
          self.getAllPurchase()
          self.loading = false
          self.activetab = 1

          
        }).catch(function(error) {
          alert('支払いの対応に失敗しました。再度、実行してください。')
          self.loading = false
        })

    },
    deleteContactData: function (id) {
      console.log(id)
      let self = this
      self.loading = true
      this.db.collection('contacts').doc(id).delete().then(function() {
          alert('お問い合わせの対応を完了しました。')
        
          self.getAllPurchase()
          self.loading = false
          self.activetab = 2

          
        }).catch(function(error) {
          alert('お問い合わせの対応に失敗しました。再度、実行してください。')
          self.loading = false
        })


    },
    getAllUser: function () {
      let self = this
      this.db.collection('users').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var hash = {}
          hash['id'] = doc.id
          hash['name'] = doc.get('name')
          hash['mail'] = doc.get('mail')
          hash['tel'] = doc.get('tel')
          
          self.users.push(hash)

        })
        self.getAllPlace()
      }).catch(function (error) {
        
      })
    },
    getAllPlace: function () {
      let self = this
      this.db.collection('places').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var hash = {}
          hash['id'] = doc.id
          hash['name'] = doc.get('name')
          
          self.places.push(hash)

        })
        self.getAllPurchase()
      }).catch(function (error) {
        
      })
    },
    getAllPurchase: function () {
      let self = this
      self.purchases = []
      this.db.collection('payments').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var hash = {}
          hash['id'] = doc.id
          hash['buyDate'] = doc.get('buyDate').toDate()
          hash['buyDateString'] = self.getYYYYMMDDStringFromDate(doc.get('buyDate').toDate())
          hash['plan'] = doc.get('plan')
          hash['name'] = doc.get('plan')
          hash['amount'] = doc.get('amount')
          const index = self.places.findIndex((p) => p.id === doc.get('place'))
          if (index === -1) {
            if (index === 0) {
              hash['place'] = '存在しないホテル'
            } else {
              hash['place'] = self.places[0].name
            }
          } else {
            hash['place'] = self.places[index].name
          }
          const uindex = self.users.findIndex((u) => u.id === doc.get('userId'))
          if (uindex === -1) {
            hash['name'] = '存在しない名前'
          } else {
            hash['name'] = self.users[uindex].name
          }
          
          if (hash['plan'] === 0) {
            hash['planString'] = '宿泊者様PCR検査'
          } else if (hash['plan'] === 2){
            if (!doc.get('passportURL')) {
              hash['passport'] = 'null'
            } else {
              hash['passport'] = doc.get('passportURL')
            }
            if (!doc.get('ticketURL')) {
              hash['ticket'] = 'null'
            } else {
              hash['ticket'] = doc.get('ticketURL')
            }
            
            
            hash['planString'] = '海外渡航陰性証明書'
          } else {
            // 3
            hash['planString'] = '医師派遣&抗原検査'
          }
          if (!doc.get('isSymptom')) {
            hash['isSymptom'] = '無'
          } else {
            hash['isSymptom'] = '有'
          }

          
          self.purchases.push(hash)

          self.purchases.sort(function(first, second){
            return second.buyDate - first.buyDate;
          });

          
        })
        self.getALLContact()
      }).catch(function (error) {
        
      })
    },
    getALLContact: function () {
      let self = this
      self.contacts = []
      this.db.collection('contacts').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var hash = {}
          hash['id'] = doc.id
          hash['name'] = doc.get('name')
          hash['mail'] = doc.get('mail')
          hash['tel'] = doc.get('tel')
          hash['content'] = doc.get('content')
          hash['type'] = doc.get('type')
          if (hash['type'] === 0) {
            hash['typeString'] = 'お問い合わせ'
          } else {
            hash['typeString'] = 'パーティー参加者様PCR検査'
            hash['institution'] = doc.get('institution')
            hash['company'] = doc.get('company')
          }
          hash['date'] = doc.get('date').toDate()
          hash['dateString'] = self.getYYYYMMDDStringFromDate(doc.get('date').toDate())
          
          self.contacts.push(hash)

          self.contacts.sort(function(first, second){
            return second.date - first.date;
          });

          
        })
      }).catch(function (error) {
        
      })
    },
    getYYYYMMDDStringFromDate: function (date) {
      console.log(date)
      var y = date.getFullYear()
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var result =  y + '/' + m + '/' + d
      return result
    },
    login: function () {
      let self = this
      if (!this.password) {
        alert('パスワードの入力がありません。')
        return
      }
      this.loading = true
      var exist = false
      this.db.collection('managers').where('password', '==', this.password).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          exist = true
          self.loading = false
          self.isConfirm = 0
          self.getAllUser()
          
        })
        if (!exist) {
          alert('パスワードが一致しません。再度入力してください。')
          self.isConfirm = 1
          self.loading = false
          
        }
      }).catch(function (error) {
        
      })
    }
  },
  created: function () {
    let self = this
    this.db = firebase.firestore()
    this.storage = firebase.storage()
  },
  mounted : function(){
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Search.vue